module.exports = __webpack_public_path__ + "static-prod-1/img/20240909133407_compressed.5737f62e.gif";